<template>
  <base-modal :show.sync="modalUsuarioLogado" modal-classes="modal-dialog-centered modal-md" body-classes="p-0">
    <template>
      <base-card header-classes="bg-white pb-5" body-classes="px-lg-3 py-lg-3" class="border-0">
        <div class="row">
          <div class="col-12 position-relative">
            <h4 class="text-secondary">Autenticação em dois fatores</h4>
            <div @click="setarModalUsuarioLogado2FA(false)" class="close-modal">
              <span>
                <i class="fas fa-times"></i>
              </span>
            </div>
          </div>
        </div>
        <p class="text-white">
          Sua conta está protegida com 2FA.
        </p>

        <p class="text-white font-weight-bold">
          Palavra-chave: <span class="cor-palavra-chave">{{ palavraChave2FA }}</span>
        </p>
        <div class="modal-2fa-avatar-row">
          <user-avatar :animal-keyword="palavraChave2FA" size="lg" clickable />
        </div>
        <p class="text-grey">
          Essa palavra identifica sua conta e pode ser usada com um código 2FA para conceder privilégios a terceiros.
          Use com cautela.
        </p>
      </base-card>
    </template>
  </base-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import UserAvatar from '@/components/layout/UserAvatar.vue';

export default {
  name: 'ModalUsuarioLogado2FA',
  components: {
    UserAvatar,
  },

  data() {
    return {};
  },

  methods: {
    ...mapActions({
      setarModalUsuarioLogado2FA: 'autenticacao2fa/setarModalUsuarioLogado2FA',
    }),
  },

  computed: {
    ...mapGetters({
      modalUsuarioLogado: 'autenticacao2fa/getModalUsuarioLogado2FA',
      palavraChave2FA: 'autenticacao2fa/getPalavraChave2FA',
    }),
  },
};
</script>

<style scoped>
.text-grey {
  color: var(--text-placeholder-gray);
}

.modal-2fa-avatar-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin: var(--spacing-sm) 0 var(--spacing-md);
}
</style>
